import ContentLoader, { Rect } from "react-content-loader/native";
import { VStack } from "@gluestack-ui/themed";

export const ServicePointsListLoader = () => {
  return (
    <VStack gap={12}>
      <VStack height="$16">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="6" ry="6" height="100%" width="100%" />
        </ContentLoader>
      </VStack>
      <VStack height="$16">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="6" ry="6" height="100%" width="100%" />
        </ContentLoader>
      </VStack>
      <VStack height="$16">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="6" ry="6" height="100%" width="100%" />
        </ContentLoader>
      </VStack>
      <VStack height="$16">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="6" ry="6" height="100%" width="100%" />
        </ContentLoader>
      </VStack>
      <VStack height="$16">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="6" ry="6" height="100%" width="100%" />
        </ContentLoader>
      </VStack>
      <VStack height="$16">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="6" ry="6" height="100%" width="100%" />
        </ContentLoader>
      </VStack>
    </VStack>
  );
};
